export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-chord/src/constant.js
// module id = 1413
// module chunks = 0